<template>
  <div class="about">
    <div class="about-wrapper">
      <h2 class="title">关于我们</h2>
      <h2 class="title">About Us</h2>
      <br />
      <h2 class="s2Title">1. 公司信息</h2>
      <h2 class="s2Title">Company Information</h2>

      <p class="s1">
        本网站由以下机构运营：
        <br /><br />This website is operated by:
      </p>
      <p class="s1">
        公司名称： 香港維珍有限公司
        <br /><br />COMPANY NAME: VEEGEN (HONGKONG) ENTERPRISE COMPANY LIMITED）
        Registered Address (注册地址) ： FLAT/RM 305 3/F YEN SHENG CENTRE 64 HOI YUEN ROAD
        KWUN TONG KL
      </p>
      <h2 class="s2Title">2. 网站的使用</h2>
      <h2 class="s2Title">Use of the Website</h2>

      <p class="s1">
        使用我们的网站即表示您已年满18岁，或在父母或法定监护人的同意和监督下使用本网站。
        <br /><br />By using our website, you confirm that you are at least 18 years old,
        or that you are using the website with the consent and supervision of a parent or
        legal guardian.
      </p>

      <p class="s1">
        您负责维护您的账户信息（包括用户名和密码）的机密性，并对您账户下发生的所有活动承担全部责任。
        <br /><br />You are responsible for maintaining the confidentiality of your
        account information (including your username and password) and for all activities
        that occur under your account.
      </p>

      <p class="s1">
        您同意在使用本网站服务时提供真实、准确、完整的个人信息及寄件信息，并及时更新。
        <br /><br />You agree to provide true, accurate, and complete personal and
        shipping information when using our website’s services, and to keep such
        information updated.
      </p>

      <h2 class="s2Title">3. 服务范围</h2>
      <h2 class="s2Title">Scope of Services</h2>

      <p class="s1">
        Vancheen是B2C跨境移动电子交易市场的应用。我们的使命是为全球消费者提供高品质、低成本的多元化产品，同时为来自不同国家的买家提供适合他们的多语种服务，给他们便捷的跨境线上购物体验。
      </p>
      <p class="s1">
        Vancheen is the application of B2C cross-border mobile e-trading marketplace. Our
        mission is to provide high-quality, low-cost diversified products to the global
        consumers, meanwhile Vancheen provides multilingual services which suitable for
        the buyers from different countries and gives them the convenice cross-border
        online shopping experience.
      </p>
      <div class="noticeBox" v-if="isApp">
        <div class="noticeVersion">{{ $t.support.currentVersion }} {{ appVersion }}</div>
        <div class="noticeButton" @click="onDownload">
          {{ $t.support.updateVersion }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isAPP, getPlatform } from "@/plugins/environment/type.js";
import { getVersionNumber } from "@/plugins/environment/model/appVersion";

export default {
  name: "AboutUs",
  data() {
    return {
      isApp: isAPP(),
      platform: getPlatform(),
      appVersion: "1.0.0",
    };
  },
  created() {
    if (this.isApp) {
      getVersionNumber().then((version) => {
        this.appVersion = version;
      });
    }
  },
  methods: {
    onDownload() {
      var url = "";
      if (this.platform == "ios") {
        url = "https://apps.apple.com/app/vancheenbusiness/id6723865467";
      } else {
        url = "https://play.google.com/store/apps/details?id=com.vancheen.business";
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.gotoPay, {
        url: url,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.about {
  width: 100%;
  display: inline-block;
  * {
    font-size: 11px;
  }
  .about-wrapper {
    width: 90%;
    margin: auto;
    padding-top: 15px;
    padding-bottom: calc(15px + env(safe-area-inset-bottom));
    .title {
      width: 100%;
      text-align: center;
      font-size: 13px;
    }
    .titleInfo {
      width: 100%;
      text-align: center;
      margin: 10px 0;
    }
    .info {
      width: 100%;
      text-align: center;
      margin: 25px 0;
    }
    .s1 {
      text-align: left;
      margin: 25px 0;
    }
    .sTitle {
      text-align: left;
      margin: 25px 0;
    }
    .noticeBox {
      width: 100%;
      color: #999;
      background: #fff;
      text-align: center;
      position: fixed;
      bottom: 0;
      left: 0;
      padding-top: 5%;
      padding-bottom: calc(5% + env(safe-area-inset-bottom));
      border-top: 1px solid #e5e5e5;
      .noticeVersion {
        margin-bottom: 5%;
      }
      .noticeButton {
        width: 80%;
        margin: auto;
        border-radius: 3rem;
        padding: 0.8rem 0;
        text-align: center;
        background: linear-gradient(left, #25b9ff, #0090e6);
        color: #ffffff;
        font-size: 1rem;
        line-height: 1;
      }
    }
  }
}
</style>
